import { c as _c } from "react/compiler-runtime";
import { Button } from "@dc/ui/components";
import type { FC, ReactNode } from "react";
import { ELEMENT_TYPE, trackElement } from "@/lib/tracking/analytics";
export interface MenuRowProps {
  icon: ReactNode;
  label: string;
  onPress: () => void;
  isLoading?: boolean;
  testId: string;
  trackingLabel: string;
}

// trackElement spreads its own data-testid, so the explicit one must come after it.
export const MenuRow: FC<MenuRowProps> = t0 => {
  const $ = _c(9);
  const {
    icon,
    label,
    onPress,
    isLoading,
    testId,
    trackingLabel
  } = t0;
  let t1;
  if ($[0] !== trackingLabel) {
    t1 = trackElement(ELEMENT_TYPE.Button, trackingLabel);
    $[0] = trackingLabel;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== icon || $[3] !== isLoading || $[4] !== label || $[5] !== onPress || $[6] !== t1 || $[7] !== testId) {
    t2 = <Button fullWidth={true} variant="light" color="default" className="justify-start px-2" startContent={icon} onPress={onPress} isLoading={isLoading} aria-label={label} {...t1} data-testid={testId}>{label}</Button>;
    $[2] = icon;
    $[3] = isLoading;
    $[4] = label;
    $[5] = onPress;
    $[6] = t1;
    $[7] = testId;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
};